import React, { useState, useEffect } from "react";
import VopHeader from "components/vop_header";
import VopFooter from "components/vop_footer";
import HomeHeader from "components/HomeHeader";
import "./style.scss";
import { useParams } from "react-router-dom";
import { solveData } from "./data.jsx";

export default function SchemeList() {
  const [headerData, setHeaderData] = useState({
    bgColor: "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
  });
  const { type } = useParams();
  useEffect(() => {
    document.title = '京东VOP开放平台-行业解决方案';

    window.scrollTo(0, 0);

    window.onscroll = () => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 50) {
        setHeaderData({
          bgColor: "#000",
        });
      } else {
        setHeaderData({
          bgColor:
            "linear-gradient(180deg, rgba(7,7,7,1) 0%,rgba(3,3,3,0) 100%)",
        });
      }
    };
  }, []);

  useEffect(() => {
  });

  return (
    <div className="solve_plan">
      <VopHeader {...headerData} contentWidth="1200px">
        <HomeHeader />
      </VopHeader>
      <div className="solve_banner">
        <img src={solveData[type].banner.bg} alt="" />
        <div className="title">{solveData[type].banner.title}</div>
        <div className="subtitle">{solveData[type].banner.subtitle}</div>
      </div>
      <div className="solve_industrypain">
        <div className="title">
          <i></i>
          <span>行业痛点</span>
          <i></i>
        </div>
        <div className="list">
          {solveData[type].industrypain.map((item, index) => (
            <div className="list-item" key={index}>
              <div className="item-content">
                <img src={item.icon} alt="" />
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="solve_solution">
        <div className="title">
          <i></i>
          <span>解决方案</span>
          <i></i>
        </div>
        <div className="list">
          {solveData[type].solution.map((item, index) => (
            <div className="list-item" key={index}>
              <div className="item-content">
                <div className="item-top">
                  <img src={item.icon} alt="" />
                  <span>{item.title}</span>
                </div>
                <div className="item-bottom">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="solve_coop">
        <div className="title">
          <i></i>
          <span>合作案例</span>
          <i></i>
        </div>
        <div className={`list ${type}`}>
          {solveData[type].coop.map((item, index) => (
            <div className="list-item" key={index}>
              <div className="item-content">
                <img src={item.img} alt="" />
              </div>
            </div>
          ))}
        </div>
      </div>
      <VopFooter />
    </div>
  );
}
